import * as t from 'io-ts';

import {makeApiType, makeEnumRuntimeType} from './apiTypes';

/*
 * Enums.
 */

export enum AccountsSetupGuideTasksEnum {
  ADD_ACCOUNT = 'add_account',
  ADD_ACCOUNT_CUSTOM_FIELD = 'add_account_custom_field',
  ADD_ACCOUNT_RULE = 'add_account_rule',
}

/*
 * Runtime type.
 */

export const RAccountsSetupGuideTasksEnum = makeEnumRuntimeType(AccountsSetupGuideTasksEnum);

const RAccountsSetupGuideDirty = t.readonly(
  t.type({
    completedTasks: t.readonlyArray(RAccountsSetupGuideTasksEnum),
  }),
);

/*
 * Type.
 */

export interface AccountsSetupGuideModel extends t.TypeOf<typeof RAccountsSetupGuideDirty> {}
export const RAccountsSetupGuide = t.clean<AccountsSetupGuideModel>(RAccountsSetupGuideDirty as any);

/*
 * IO methods.
 */

function parseAccountsSetupGuide(src: any): AccountsSetupGuideModel {
  return {
    completedTasks: src.completed_tasks,
  };
}

/*
 * API type.
 */

export const ApiAccountsSetupGuide = makeApiType(
  'accountsSetupGuide',
  RAccountsSetupGuide,
  parseAccountsSetupGuide,
);
